import React, { FunctionComponent } from "react";

import { IOpenedFormInfo } from "@multiweb/types/multiweb";
import { QAProps } from "@multiweb/types/react";
import { NavigationSection } from "../../navigation";
import { OpenedFormItemInfo, OpenedProfileInfo } from "../../openedItems";
import { OpenedForm } from "../OpenedForm";
import { OpenedFormItem } from "../OpenedFormItem";
import { OpenedProfile } from "../OpenedProfile";

export type OpenedItemComponentProps = {
    /** Sekce, ve které je profil vykreslený. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Informace o otevřeném formuláři */
    openedFormInfo?: IOpenedFormInfo;
} & QAProps;

/**
 * Vykreslí vhodný typ komponenty pro zobrazení otevřeného formuláře.
 * @param openedFormInfo Údaje o otevřeném formuláři.
 * @param qa
 * @return Vytvořená komponenta.
 */
export const OpenedItemComponent: FunctionComponent<OpenedItemComponentProps> = ({ openedFormInfo, section, qa }) => {
    if (!openedFormInfo) {
        return null;
    }
    const { formInstanceId, menuItemId, profileId } = openedFormInfo;
    if (profileId && menuItemId) {
        return <OpenedProfile openedProfileInfo={openedFormInfo as OpenedProfileInfo} qa={qa} section={section} />;
    } else if (menuItemId) {
        return <OpenedFormItem openedFormItemInfo={openedFormInfo as OpenedFormItemInfo} qa={qa} section={section} />;
    } else {
        return <OpenedForm formInstanceId={formInstanceId} qa={qa} section={section}/>;
    }
};
